import './App.css';

import { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import MainPage from './Views/Pages/Main';


function App() {
  useEffect(() => {
    AOS.init({
      duration: 1500,
    });
  });
  return (
      <MainPage />
  );
}

export default App;
